import React from 'react'
import './Blogs.scss'
import blog1 from '../../../assets/images/0dcb5723094a715f5137f751440e6eae.jpg'
import blog2 from '../../../assets/images/ca96b7422fc577ee4f000a1900362297.jpg'
import blog3 from '../../../assets/images/8726a54f2feb59b04924591b0e5d25f3.png'
import blog4 from '../../../assets/images/d396b575c522c8b2614782bfa46bac5c.png'


import BlogCard from './BlogCard/BlogCard'

const Blogs = () => {
    return (
        <div className='Blogs-main-container'>
            <div className="Blogs-container">
                <h3>Blogs</h3>
                <h5>A Data Analytics Journey Through Brand Websites</h5>
            </div>
            <div className='blog-upper-container'>
                <div className='blog-upper-box-left'>
                    <img src={blog1} alt='' />
                </div>
                <div className='blog-upper-box-right'>
                    <p>By <span>John Doe</span>   l   Aug 07, 2021 </p>
                    <h2>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor.</h2>
                    <p>In fringilla bibendum lacus. Sed sed risus nec tortor volutpat gravida. Interdum et malesuada fames ac ante ipsum primis in faucibus. Integer viverra porta augue, in suscipit lacus ornare vitae. Aliquam erat volutpat. Morbi nibh quam, cursus vitae volutpat sit amet, molestie laoreet nunc. Duis vestibulum nec erat sed ullamcorper. Phasellus vehicula volutpat aliquet. Etiam consectetur urna quam. Phasellus id pulvinar augue. Curabitur et justo ac arcu eleifend varius. Sed vel leo libero. Mauris rutrum pretium massa, vitae scelerisque purus maximus a. </p>
                </div>
            </div>

            <div className='blog-lowerGrid-container'>
                <BlogCard img={blog2} heading="Sit amet, consectetur adipiscing elit, sed do eiusmod tempor." para="Morbi nibh quam, cursus vitae volutpat sit amet, molestie laoreet nunc. Duis vestibulum nec erat sed ullamcorper. Phasellus vehicula volutpat aliquet. Etiam consectetur urna quam. Phasellus id pulvinar augue. Curabitur et justo ac arcu eleifend varius. Sed vel leo libero. Mauris rutrum pretium massa, vitae scelerisque. " />
                <BlogCard img={blog3} heading="Sit amet, consectetur adipiscing elit, sed do eiusmod tempor." para="Morbi nibh quam, cursus vitae volutpat sit amet, molestie laoreet nunc. Duis vestibulum nec erat sed ullamcorper. Phasellus vehicula volutpat aliquet. Etiam consectetur urna quam. Phasellus id pulvinar augue. Curabitur et justo ac arcu eleifend varius. Sed vel leo libero. Mauris rutrum pretium massa, vitae scelerisque. " />
                <BlogCard img={blog4} heading="Sit amet, consectetur adipiscing elit, sed do eiusmod tempor." para="Morbi nibh quam, cursus vitae volutpat sit amet, molestie laoreet nunc. Duis vestibulum nec erat sed ullamcorper. Phasellus vehicula volutpat aliquet. Etiam consectetur urna quam. Phasellus id pulvinar augue. Curabitur et justo ac arcu eleifend varius. Sed vel leo libero. Mauris rutrum pretium massa, vitae scelerisque. " />
            </div>

        </div>
    )
}

export default Blogs